import { ContentNode, HeroOptions } from '@/types/models'
import {
  isNonEmptyArray,
  isNonEmptyObject,
  isNonEmptyString
} from '@/utils/checks'

export const isVideoBlogHero = ({
  heroOptions
}: {
  heroOptions: HeroOptions
}): boolean =>
  isNonEmptyObject(heroOptions) &&
  isNonEmptyArray(heroOptions?.mediaType) &&
  isNonEmptyString(heroOptions?.mediaSrc) &&
  heroOptions?.mediaType?.includes('Video')

export const isVideoBlogHeroWithCoverImage = ({
  heroOptions
}: {
  heroOptions: HeroOptions
}): boolean => {
  return (
    isVideoBlogHero({ heroOptions }) &&
    isNonEmptyString(heroOptions?.coverImage)
  )
}
export const isImageBlogHero = ({
  heroOptions
}: {
  heroOptions: HeroOptions
}): boolean => {
  return (
    isNonEmptyObject(heroOptions) &&
    isNonEmptyArray(heroOptions?.mediaType) &&
    isNonEmptyString(heroOptions?.mediaSrc) &&
    heroOptions?.mediaType?.includes('Image')
  )
}

export const hasBgColor = (themeColor: unknown): themeColor is string[] => {
  return isNonEmptyArray(themeColor) && isNonEmptyString(themeColor[0])
}
